module.exports = __webpack_public_path__ + "static/img/18-1.a9bbfd95.jpg";